import { render, staticRenderFns } from "./mycoupons.vue?vue&type=template&id=4318074d&scoped=true"
import script from "./mycoupons.vue?vue&type=script&lang=js"
export * from "./mycoupons.vue?vue&type=script&lang=js"
import style0 from "./mycoupons.vue?vue&type=style&index=0&id=4318074d&prod&lang=less"
import style1 from "./mycoupons.vue?vue&type=style&index=1&id=4318074d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318074d",
  null
  
)

export default component.exports